import { z } from "zod";

/** POST /v1/admin/reports/:id/decide — içerik bildirimi kararı (K-076, K-083) */
export const DecideReportBody = z.object({
  decision: z.enum(["uphold", "reject"]),
  /** gerekçe: bildirene ve içerik sahibine gönderilir (DSA) */
  note: z.string().trim().min(3).max(1000),
});
export type DecideReportBody = z.infer<typeof DecideReportBody>;

/** POST /v1/admin/messages/:id/moderate — işaretli mesaj: temizle (sorun yok) ya da metni kaldır */
export const ModerateMessageBody = z.object({
  action: z.enum(["clear", "remove"]),
  note: z.string().trim().min(3).max(500),
});

/** POST /v1/admin/documents/:id/decide — doğrulama belgesi (K-043, K-050) */
export const DecideDocumentBody = z
  .object({
    approve: z.boolean(),
    reason: z.string().trim().min(3).max(500).optional(),
    /** sigorta, lisans gibi süreli belgeler */
    expiresOn: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
  })
  .refine((b) => b.approve || b.reason !== undefined, {
    message: "redde gerekçe gerekli",
    path: ["reason"],
  });

/** GET /v1/admin/accounting/* — dönem (dahil başlangıç, hariç bitiş), en fazla 1 yıl */
export const LedgerRangeQuery = z
  .object({
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    market: z
      .string()
      .regex(/^[A-Z]{2}$/)
      .optional(),
  })
  .refine((q) => q.from < q.to, { message: "from < to", path: ["to"] })
  .refine((q) => Date.parse(q.to) - Date.parse(q.from) <= 366 * 86_400_000, {
    message: "en fazla 1 yıl",
    path: ["to"],
  });

/** POST /v1/service-requests — "aradığın hizmet yok mu?" (K-011, K-035); misafir de bırakabilir */
export const CreateServiceRequestBody = z
  .object({
    market: z
      .string()
      .regex(/^[A-Z]{2}$/)
      .default("MT"),
    description: z.string().trim().min(10).max(2000),
    locale: z
      .string()
      .regex(/^[a-z]{2}$/)
      .optional(),
    categoryId: z.string().uuid().optional(),
    /** giriş yapmamış ziyaretçide zorunlu */
    contact: z
      .object({
        name: z.string().trim().min(2).max(160),
        email: z.string().trim().toLowerCase().email().max(255),
        phone: z
          .string()
          .regex(/^\+[1-9]\d{6,14}$/)
          .optional(),
      })
      .optional(),
  })
  .strict();
export type CreateServiceRequestBody = z.infer<typeof CreateServiceRequestBody>;

/** PATCH /v1/admin/service-requests/:id */
export const UpdateServiceRequestBody = z
  .object({
    status: z
      .enum(["new", "contacted", "in_review", "accepted", "rejected", "added_to_catalog"])
      .optional(),
    adminNotes: z.string().trim().max(4000).nullable().optional(),
    assignedStaffId: z.string().uuid().nullable().optional(),
    resultingServiceId: z.string().uuid().nullable().optional(),
  })
  .strict()
  .refine((b) => Object.keys(b).length > 0, { message: "boş güncelleme" })
  .refine((b) => b.status !== "added_to_catalog" || b.resultingServiceId, {
    message: "kataloğa eklenen hizmet gerekli",
    path: ["resultingServiceId"],
  });
